module.exports = __webpack_public_path__ + "static/6-TECHNOLOGIES-WORKPLACE-c9d6c3444cd411f7d8710f372b8b66d7.png";